import React, { Fragment, useEffect, useState } from "react";
import "./index.less";
import { Button, Dropdown, List, Tooltip } from "antd";
import { AvatarCom, AvatarComProps, RelationshipType } from "../../AvatarCom";
import { StopOutlined } from "@ant-design/icons";
import { useTranslate } from "@obsbot/remo-i18n";
import { useChannelRoomStore, useFriendStore, useGlobalStore } from "@obsbot/remo-stores";
import { BindRelationshipModal } from "../../BindRelationshipModal";
import { CustomModal } from "../../CustomModal";
import { useParams } from "react-router-dom";
import { ListEmpty } from "./ListEmpty";
import { sortFriends } from "../../../utils/util";
import {
    AddFriend,
    changeIntimate,
    dissolutionFriend,
    handleApplication,
    revokeApplication,
} from "@obsbot/remo-server-api";
import { eventBus } from "@obsbot/remo-utils";
import {
    AgreeIcon,
    ChatMoreIcon,
    DisagreeIcon,
    RevokeIcon,
    ToChatIcon,
} from "../../SvgIconCom/ChatContentIcon";
import EmptyContactPNG from "../icons/empty-contact.png";
type dropMenuItem = {
    key: string;
    label: string;
};

export interface UserProfile {
    profileCustomField: [];
    nick: string;
    userID: string;
    avatar: string;
    [param: string]: any;
}
export interface ContactItem extends AvatarComProps {
    userID: string;
    timestamp?: number;
    source?: string;
    remark?: string;
    profile?: UserProfile;
    groupList?: [];
    friendCustomField?: [];
    addTime?: number;
    conversationID?: string;
    isPinned?: boolean;
    messageRemindType?: string;
    userProfile?: any;
    handleStatus?: number;
    applicationId?: number; // 申请列表ID
}

export interface ContactListProps {
    contactList?: ContactItem[];
    // 对应私信、列表、申请等模式
    modeType?: "list-all" | "list-online" | "list-relation" | "apply-in" | "apply-out";
    relationshipGroup?: RelationshipType;
    hasSelectedUser?: boolean;
    isSelectedClick?: () => void;
    onClick?: (key: string, item: AvatarComProps) => void; // 点击联系人时的回调函数
}
export const ContactList: React.FC<ContactListProps> = ({
    contactList = [],
    modeType = "list-all",
    hasSelectedUser = false, // 用于跟踪选中的用户
    relationshipGroup,
    isSelectedClick,
    onClick,
}) => {
    const params = useParams();
    const t = useTranslate();
    const { application, conversation, friendList, rtm, updateConversation } = useFriendStore();
    const friendStore = useFriendStore();
    const { userInfo } = useGlobalStore();
    const { blockedUsers } = useChannelRoomStore();
    const [curContactList, setCurContactList] = useState<ContactItem[]>(contactList);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [bindAction, setBindAction] = useState<string>("add");
    const [showCustomModal, setShowCustomModal] = useState<boolean>(false);
    const [showContextMenu, setShowContextMenu] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<ContactItem | null>(null); // 用于跟踪选中的用户
    const [customDelModalInfo, setCustomDelModalInfo] = useState({
        type: "delete",
        renderHeader: t("chat.delete-friend"),
        content: t("chat.delete-friend-confirm"),
    });
    const dropdownItems = (relationship?: RelationshipType): dropMenuItem[] => {
        let cur = [{ label: t("chat.delete"), key: "delete" }];
        const dissolution = [
                { label: t("chat.relationship-change"), key: "change" },
                { label: t("chat.dissolution"), key: "dissolution" },
            ],
            add = { label: t("chat.addIntimacy"), key: "add" };
        cur = relationship ? [...dissolution, ...cur] : [add, ...cur];
        return [...cur];
    };

    useEffect(() => {
        if (params.id) {
            const selected = curContactList.find(item => item.userID === params.id);
            if (selected) {
                setSelectedUser(selected);
            }
        }
    }, [params.id, curContactList]);
    useEffect(() => {
        // 模拟数据 ， 如果需要
        let tempContactList: ContactItem[] = [];
        let tempLoopList: any[] = [];
        switch (modeType) {
            case "apply-out": {
                tempLoopList = application.sentRequests || [];
                for (const item of tempLoopList) {
                    tempContactList.push({
                        userID: item.receiverId,
                        userName: item.receiverNickname,
                        avatar: item.receiverLogo,
                        newMessage: 0,
                        size: 32,
                        status: undefined,
                        handleStatus: item.status,
                        relationship: undefined,
                        applicationId: item.id,
                    });
                }
                break;
            }
            case "apply-in": {
                tempLoopList = application.receivedRequests || [];
                for (const item of tempLoopList) {
                    tempContactList.push({
                        userID: item.senderId,
                        userName: item.senderNickname,
                        avatar: item.senderLogo,
                        newMessage: 0,
                        size: 32,
                        status: undefined,
                        handleStatus: item.status,
                        relationship: undefined,
                        applicationId: item.id,
                    });
                }
                break;
            }
            default: {
                for (const item of friendList) {
                    const profile = item.profile;
                    const relationship = getRelationship(item?.groupList);
                    const userStatus = profile.profileCustomField?.[0]?.value;
                    if (!relationshipGroup || relationshipGroup === relationship) {
                        if (modeType === "list-online" && userStatus !== "online") {
                            continue;
                        }
                        tempContactList.push({
                            userID: profile.userID,
                            userName: profile.nick || profile.userID,
                            avatar: profile.avatar === "" ? undefined : profile.avatar,
                            newMessage: undefined,
                            size: 32,
                            status: userStatus === "invisible" ? "offline" : userStatus,
                            relationship: relationship,
                        });
                    }
                }
                tempContactList = sortFriends(tempContactList);
                break;
            }
        }
        setCurContactList([...tempContactList]); // 从服务器获取数据并更新状态
        if (!hasSelectedUser) {
            setSelectedUser(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasSelectedUser, modeType, application, friendList, friendStore, relationshipGroup]);

    const getRelationship = (groupList: any[]): RelationshipType | undefined => {
        const relationshipTypes = ["lovers", "buddy", "bosom_friend"];
        let result: RelationshipType | undefined = undefined;
        groupList &&
            groupList.forEach((item: RelationshipType) => {
                if (relationshipTypes.includes(item)) {
                    result = item;
                }
            });
        return result;
    };

    const onMenuClick = (item: ContactItem, e: any): void => {
        setSelectedUser(item);
        switch (e.key) {
            case "delete": {
                setCustomDelModalInfo({
                    type: "delete",
                    renderHeader: t("chat.delete-friend"),
                    content: t("chat.delete-friend-confirm", { friend: item.userName }),
                });
                // 删除好友
                setShowCustomModal(true);
                break;
            }
            case "dissolution": {
                setCustomDelModalInfo({
                    type: "dissolution",
                    renderHeader: t("chat.dissolution-friend"),
                    content: t("chat.dissolution-friend-confirm"),
                });
                // 解除亲密关系
                setShowCustomModal(true);
                break;
            }
            case "change": {
                setBindAction("change");
                // 变更亲密关系
                setShowModal(true);
                break;
            }
            case "add": {
                setBindAction("add");
                // 添加亲密关系
                setShowModal(true);

                break;
            }
            default: {
                break;
            }
        }
    };

    const handleApplicationEvent = async (info: any, type: string): Promise<void> => {
        const flag = type === "agree" ? 1 : 0;
        if (!rtm) {
            console.log("rtm is undefined");
            return;
        }
        if (userInfo) {
            const res = await handleApplication({
                userNickname: userInfo.nickname,
                userLogo: userInfo.logo,
                friendId: info.userID,
                friendNickname: info.userName,
                friendLogo: info.avatar,
                flag, // 0-拒绝 1-同意
                relationType: getRelationType(info.relationship),
            });
            if (res.code === "200" && res.data.status === "online") {
                eventBus.emit("show-message", {
                    message: t("chat.add-friend-success-tips", { userName: info.userName }),
                    type: "success",
                });
            }
        } else {
            eventBus.emit("show-message", {
                message: t("error_code.SDK.500"),
                type: "warning",
            });
        }
    };

    const BindRelationship = async (relationship: RelationshipType): Promise<void> => {
        if (rtm && relationship && selectedUser) {
            // 先往后端发请求，校验是否可以发起申请！
            let res;
            if (bindAction === "add") {
                try {
                    res = await AddFriend({
                        receiverId: selectedUser.userID,
                        senderNickname: selectedUser.userName || "",
                        senderLogo: selectedUser.avatar || "",
                        relationType: getRelationType(relationship),
                        blockMsgBox: false,
                    });
                } catch (error) {
                    res = error;
                }
            } else {
                if (selectedUser.relationship === relationship) {
                    const desc = t("relationship." + relationship);
                    eventBus.emit("show-message", {
                        message: t("relationship.change-intimate-same-failed", {
                            relationship: desc,
                        }),
                        type: "warning",
                    });
                    return;
                }
                // 调用变更亲密关系接口
                try {
                    res = await changeIntimate({
                        friendId: selectedUser.userID,
                        userId: userInfo?.user_id || "",
                        relationType: getRelationType(relationship),
                    });
                } catch (error) {
                    res = error;
                }
            }
            if (res.code === "200") {
                // // 如果可以再发送申请
                // const resSend = await rtm.sendPeerMessage(CustomType.Custom, selectedUser.userID, {
                //     description: ICustomPayloadDescription.IntimateRelation,
                //     // 记录亲密关系申请信息
                //     extension: JSON.stringify({
                //         relationship,
                //         from: {
                //             userID: userInfo?.user_id,
                //             userName: userInfo?.nickname,
                //             avatar: userInfo?.logo,
                //         },
                //         to: {
                //             userID: selectedUser.userID,
                //             userName: selectedUser.userName,
                //             avatar: selectedUser.avatar,
                //         },
                //         status: "process",
                //         time: undefined,
                //         action: bindAction, // 操作类型， 添加、变更
                //     }),
                //     data: res?.data ? res.data + "" : "",
                // });
                eventBus.emit("show-message", {
                    message: t("relationship.add-relation-success"),
                    type: "success",
                });
                // if (resSend) {
                setShowModal(false);
                // 将申请消息的腾讯私聊消息ID关联到后端
                //     setMsgId({
                //         msgId: resSend,
                //         id: res.data,
                //     });
                // }
            } else {
                console.log("[WEB DEBUG] 添加亲密关系", res);
                // eventBus.emit("show-message", {
                //     message: t("error_code." + res.code),
                //     type: "error",
                // });
            }
        }
    };

    const onConfirm = async (): Promise<void> => {
        if (!rtm || !selectedUser) {
            return;
        }
        const relationshipType = 0; // 0-普通好友 1-情侣 2-闺蜜 3-兄弟
        let release = 0; // 0-解除亲密关系， 1-删除好友
        const params = {
            friendId: selectedUser.userID,
            relationType: relationshipType,
            release,
            userNickname: "",
            friendNickname: "",
        };
        if (customDelModalInfo.type === "delete") {
            release = 1;
            params.release = 1;
        } else if (customDelModalInfo.type === "dissolution" && selectedUser.relationship) {
            params.relationType = getRelationType(selectedUser.relationship);
            params.release = 0;
            params.userNickname = userInfo?.nickname || "";
            params.friendNickname = selectedUser.userName || "";
        }
        const res = await dissolutionFriend(params);
        res.code === "200" && setShowCustomModal(false);
    };

    const handleRevoke = (item: ContactItem): void => {
        revokeApplication(item.userID);
    };

    const toChatPage = async (item: ContactItem): Promise<void> => {
        if (!modeType.includes("list")) {
            return;
        }
        onClick && onClick("TextChatPage", item);
        if (
            !conversation.conversationList.find(e => e.conversationID === "C2C" + item.userID) &&
            rtm
        ) {
            let msgType = "AcceptAndNotify";
            if (blockedUsers.includes(item.userID)) {
                msgType = "Discard";
            }
            updateConversation(item.userID, item.userName, item.avatar, msgType);
        }
    };

    const footer = (
        <div className="modal-button-group">
            <div
                className="modal-button-item button-normal"
                onClick={() => setShowCustomModal(false)}
            >
                {t("cancel")}
            </div>
            <div className="modal-button-item button-danger" onClick={onConfirm}>
                {t("confirm")}
            </div>
        </div>
    );

    return (
        <div className={`contact-list ${curContactList.length === 0 ? "empty-list" : ""}`}>
            <List
                className="list-content"
                dataSource={curContactList}
                locale={{ emptyText: <ListEmpty emptyImg={EmptyContactPNG} modeType={modeType} /> }}
                renderItem={(item, index) => (
                    <List.Item
                        key={index}
                        className={`${selectedUser?.userID === item.userID ? "selected" : ""} ${item.isPinned ? "pinned" : ""}`}
                        onClick={() => {
                            setSelectedUser(item);
                            isSelectedClick && isSelectedClick();
                            if (showContextMenu) {
                                setShowContextMenu(false);
                            }
                        }}
                        onDoubleClick={e => {
                            if ((e.target as Element).closest(".contact-list-btn")) {
                                return;
                            }
                            toChatPage(item);
                        }}
                    >
                        <span className="avatar-in-list">
                            <AvatarCom {...item} modeType={modeType} />
                            {item.messageRemindType === "Discard" ? (
                                <StopOutlined
                                    style={{ color: "#DD4141" }}
                                    onPointerMoveCapture={undefined}
                                    onPointerOverCapture={undefined}
                                />
                            ) : null}
                        </span>
                        {modeType.includes("list") && (
                            <Fragment>
                                <Tooltip
                                    arrow={false}
                                    getPopupContainer={() =>
                                        document.getElementsByClassName(
                                            "main-page-layout-inner",
                                        )[0] as HTMLElement
                                    }
                                    placement="bottom"
                                    title={t("chat.sidebar-msg")}
                                >
                                    <Button
                                        className="btn-right"
                                        icon={<ToChatIcon className="contact-list-btn-icon" />}
                                        type="text"
                                        onClick={toChatPage.bind(this, item)}
                                    ></Button>
                                </Tooltip>
                                <Tooltip
                                    arrow={false}
                                    getPopupContainer={() =>
                                        document.getElementsByClassName(
                                            "main-page-layout-inner",
                                        )[0] as HTMLElement
                                    }
                                    placement="bottom"
                                    title={t("chat.more")}
                                >
                                    <Dropdown.Button
                                        arrow={false}
                                        className="contact-list-btn"
                                        getPopupContainer={() => document.body}
                                        icon={<ChatMoreIcon className="contact-list-btn-icon" />}
                                        menu={{
                                            items: dropdownItems(item?.relationship),
                                            onClick: onMenuClick.bind(this, item),
                                        }}
                                        overlayClassName="dropdown-content-menu"
                                        trigger={["click"]}
                                        type="text"
                                        onClick={e => e.stopPropagation()}
                                    ></Dropdown.Button>
                                </Tooltip>
                            </Fragment>
                        )}
                        {modeType === "apply-in" && item.handleStatus === 0 && (
                            <Fragment>
                                <Tooltip
                                    arrow={false}
                                    placement="bottom"
                                    title={t("chat.disagree")}
                                >
                                    <Button
                                        className="btn-right disagree-btn"
                                        icon={<DisagreeIcon />}
                                        size="large"
                                        type="text"
                                        onClick={handleApplicationEvent.bind(
                                            this,
                                            item,
                                            "disagree",
                                        )}
                                    ></Button>
                                </Tooltip>
                                <Tooltip arrow={false} placement="bottom" title={t("chat.agree")}>
                                    <Button
                                        className="agree-btn"
                                        icon={<AgreeIcon />}
                                        size="large"
                                        type="text"
                                        onClick={handleApplicationEvent.bind(this, item, "agree")}
                                    ></Button>
                                </Tooltip>
                            </Fragment>
                        )}
                        {modeType === "apply-out" && (
                            <Tooltip arrow={false} placement="bottom" title={t("chat.revoke")}>
                                <Button
                                    className="revoke-btn"
                                    icon={<RevokeIcon />}
                                    type="link"
                                    onClick={handleRevoke.bind(this, item)}
                                ></Button>
                            </Tooltip>
                        )}
                    </List.Item>
                )}
            />
            <BindRelationshipModal
                action={bindAction}
                setVisible={show => setShowModal(show)}
                visible={showModal}
                onOk={BindRelationship}
            />
            <CustomModal
                className="delete-modal"
                footer={footer}
                open={showCustomModal}
                renderHeader={customDelModalInfo.renderHeader}
                setVisible={setShowCustomModal}
                width={392}
            >
                <div className="delete-modal-content">{customDelModalInfo.content}</div>
            </CustomModal>
        </div>
    );
};

export const getRelationType = (relationship?: string): number => {
    // 0-普通好友 1-情侣 2-闺蜜 3-兄弟
    switch (relationship) {
        case "lovers": {
            return 1;
        }
        case "bosom_friend": {
            return 2;
        }
        case "buddy": {
            return 3;
        }
        default: {
            return 0;
        }
    }
};
